export class TimeTrialHUD {
  private container: HTMLElement;
  private trackName: HTMLElement;
  private lapDisplay: HTMLElement;
  private timeDisplay: HTMLElement;
  private lapTimeDisplay: HTMLElement;
  private bestTimeDisplay: HTMLElement;
  private countdownOverlay: HTMLElement;
  private lapTimePopup: HTMLElement;
  private raceCompleteScreen: HTMLElement;

  constructor() {
    this.container = this.createContainer();
    this.trackName = this.createTrackName();
    this.lapDisplay = this.createLapDisplay();
    this.timeDisplay = this.createTimeDisplay();
    this.lapTimeDisplay = this.createLapTimeDisplay();
    this.bestTimeDisplay = this.createBestTimeDisplay();
    this.countdownOverlay = this.createCountdownOverlay();
    this.lapTimePopup = this.createLapTimePopup();
    this.raceCompleteScreen = this.createRaceCompleteScreen();

    this.container.appendChild(this.trackName);
    this.container.appendChild(this.lapDisplay);
    this.container.appendChild(this.timeDisplay);
    this.container.appendChild(this.lapTimeDisplay);
    this.container.appendChild(this.bestTimeDisplay);

    document.getElementById('ui-container')?.appendChild(this.container);
    document.getElementById('ui-container')?.appendChild(this.countdownOverlay);
    document.getElementById('ui-container')?.appendChild(this.lapTimePopup);
    document.getElementById('ui-container')?.appendChild(this.raceCompleteScreen);

    this.hide();
  }

  private createContainer(): HTMLElement {
    const container = document.createElement('div');
    container.id = 'timetrial-hud';
    container.style.cssText = `
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      font-family: 'Courier New', monospace;
      z-index: 100;
    `;
    return container;
  }

  private createTrackName(): HTMLElement {
    const el = document.createElement('div');
    el.style.cssText = `
      color: #00ffff;
      font-size: 24px;
      font-weight: bold;
      text-shadow: 0 0 10px #00ffff;
      letter-spacing: 3px;
    `;
    return el;
  }

  private createLapDisplay(): HTMLElement {
    const el = document.createElement('div');
    el.style.cssText = `
      color: #ffffff;
      font-size: 20px;
      text-shadow: 0 0 8px #ffffff;
      letter-spacing: 2px;
    `;
    return el;
  }

  private createTimeDisplay(): HTMLElement {
    const el = document.createElement('div');
    el.style.cssText = `
      color: #ffff00;
      font-size: 48px;
      font-weight: bold;
      text-shadow: 0 0 15px #ffff00;
      letter-spacing: 2px;
      font-variant-numeric: tabular-nums;
    `;
    return el;
  }

  private createLapTimeDisplay(): HTMLElement {
    const el = document.createElement('div');
    el.style.cssText = `
      color: #88ff88;
      font-size: 18px;
      text-shadow: 0 0 8px #88ff88;
      letter-spacing: 1px;
    `;
    return el;
  }

  private createBestTimeDisplay(): HTMLElement {
    const el = document.createElement('div');
    el.style.cssText = `
      color: #ff88ff;
      font-size: 16px;
      text-shadow: 0 0 8px #ff88ff;
      letter-spacing: 1px;
    `;
    return el;
  }

  private createCountdownOverlay(): HTMLElement {
    const el = document.createElement('div');
    el.id = 'countdown-overlay';
    el.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 120px;
      font-weight: bold;
      color: #00ffff;
      text-shadow: 0 0 30px #00ffff, 0 0 60px #00ffff;
      font-family: 'Courier New', monospace;
      z-index: 200;
      opacity: 0;
      transition: opacity 0.2s, transform 0.2s;
    `;
    return el;
  }

  private createLapTimePopup(): HTMLElement {
    const el = document.createElement('div');
    el.style.cssText = `
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      font-family: 'Courier New', monospace;
      z-index: 150;
      opacity: 0;
      transition: opacity 0.3s;
      pointer-events: none;
    `;
    return el;
  }

  private createRaceCompleteScreen(): HTMLElement {
    const screen = document.createElement('div');
    screen.id = 'race-complete';
    screen.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.85);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 15px;
      z-index: 200;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.5s ease;
      font-family: 'Courier New', monospace;
    `;

    screen.innerHTML = `
      <div id="rc-title" style="color: #00ff00; font-size: 64px; font-weight: bold; text-shadow: 0 0 30px #00ff00; letter-spacing: 8px;">
        RACE COMPLETE
      </div>
      <div id="rc-time" style="color: #ffff00; font-size: 48px; font-weight: bold; text-shadow: 0 0 20px #ffff00; margin-top: 20px;">
        00:00.000
      </div>
      <div id="rc-best" style="color: #ff88ff; font-size: 24px; text-shadow: 0 0 10px #ff88ff;">
        BEST: 00:00.000
      </div>
      <div id="rc-newrecord" style="color: #ff0000; font-size: 32px; font-weight: bold; text-shadow: 0 0 15px #ff0000; display: none;">
        NEW RECORD!
      </div>
      <div id="rc-laps" style="color: #ffffff; font-size: 18px; margin-top: 20px;">
      </div>
      <div style="color: #888888; font-size: 16px; margin-top: 30px; letter-spacing: 2px;">
        PRESS ENTER TO RESTART | N FOR NEXT TRACK
      </div>
    `;

    return screen;
  }

  public show(): void {
    this.container.style.display = 'flex';
  }

  public hide(): void {
    this.container.style.display = 'none';
    this.countdownOverlay.style.opacity = '0';
    this.lapTimePopup.style.opacity = '0';
    this.raceCompleteScreen.style.opacity = '0';
    this.raceCompleteScreen.style.pointerEvents = 'none';
  }

  public updateTrackInfo(name: string, laps: number, bestTime: number | null): void {
    this.trackName.textContent = name.toUpperCase();
    this.lapDisplay.textContent = `LAP 1/${laps}`;
    this.timeDisplay.textContent = '00:00.000';
    this.lapTimeDisplay.textContent = 'LAP TIME: --:--.---';

    if (bestTime !== null) {
      this.bestTimeDisplay.textContent = `BEST: ${this.formatTime(bestTime)}`;
    } else {
      this.bestTimeDisplay.textContent = 'BEST: --:--.---';
    }
  }

  public updateLap(currentLap: number, totalLaps: number): void {
    this.lapDisplay.textContent = `LAP ${currentLap}/${totalLaps}`;
  }

  public updateTime(raceTime: number, lapTime: number, _currentLap: number): void {
    this.timeDisplay.textContent = this.formatTime(raceTime);
    this.lapTimeDisplay.textContent = `LAP TIME: ${this.formatTime(lapTime)}`;
  }

  public showCountdown(count: number): void {
    if (count <= 0) {
      this.countdownOverlay.textContent = 'GO!';
      this.countdownOverlay.style.color = '#00ff00';
      this.countdownOverlay.style.textShadow = '0 0 30px #00ff00, 0 0 60px #00ff00';
      this.countdownOverlay.style.opacity = '1';
      this.countdownOverlay.style.transform = 'translate(-50%, -50%) scale(1.2)';

      setTimeout(() => {
        this.countdownOverlay.style.opacity = '0';
      }, 500);
    } else {
      this.countdownOverlay.textContent = count.toString();
      this.countdownOverlay.style.color = '#00ffff';
      this.countdownOverlay.style.textShadow = '0 0 30px #00ffff, 0 0 60px #00ffff';
      this.countdownOverlay.style.opacity = '1';
      this.countdownOverlay.style.transform = 'translate(-50%, -50%) scale(1)';
    }
  }

  public showLapTime(lapTime: number, bestLapTime: number | null): void {
    const isBest = bestLapTime === null || lapTime <= bestLapTime;

    this.lapTimePopup.innerHTML = `
      <div style="color: ${isBest ? '#00ff00' : '#ffffff'}; font-size: 32px; font-weight: bold; text-shadow: 0 0 15px ${isBest ? '#00ff00' : '#ffffff'};">
        LAP COMPLETE
      </div>
      <div style="color: ${isBest ? '#00ff00' : '#ffff00'}; font-size: 48px; font-weight: bold; text-shadow: 0 0 20px ${isBest ? '#00ff00' : '#ffff00'};">
        ${this.formatTime(lapTime)}
      </div>
      ${isBest ? '<div style="color: #ff00ff; font-size: 24px; text-shadow: 0 0 10px #ff00ff;">BEST LAP!</div>' : ''}
    `;

    this.lapTimePopup.style.opacity = '1';

    setTimeout(() => {
      this.lapTimePopup.style.opacity = '0';
    }, 2000);
  }

  public showRaceComplete(
    totalTime: number,
    lapTimes: number[],
    bestTime: number | null,
    isNewRecord: boolean
  ): void {
    const timeEl = this.raceCompleteScreen.querySelector('#rc-time') as HTMLElement;
    const bestEl = this.raceCompleteScreen.querySelector('#rc-best') as HTMLElement;
    const recordEl = this.raceCompleteScreen.querySelector('#rc-newrecord') as HTMLElement;
    const lapsEl = this.raceCompleteScreen.querySelector('#rc-laps') as HTMLElement;

    timeEl.textContent = this.formatTime(totalTime);
    bestEl.textContent = bestTime !== null ? `BEST: ${this.formatTime(bestTime)}` : '';
    recordEl.style.display = isNewRecord ? 'block' : 'none';

    // Show lap times
    let lapsHtml = '<div style="text-align: center;">';
    lapTimes.forEach((time, i) => {
      lapsHtml += `<div>Lap ${i + 1}: ${this.formatTime(time)}</div>`;
    });
    lapsHtml += '</div>';
    lapsEl.innerHTML = lapsHtml;

    this.raceCompleteScreen.style.opacity = '1';
    this.raceCompleteScreen.style.pointerEvents = 'auto';
  }

  public hideRaceComplete(): void {
    this.raceCompleteScreen.style.opacity = '0';
    this.raceCompleteScreen.style.pointerEvents = 'none';
  }

  private formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const ms = Math.floor((seconds % 1) * 1000);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
  }

  public destroy(): void {
    this.container.remove();
    this.countdownOverlay.remove();
    this.lapTimePopup.remove();
    this.raceCompleteScreen.remove();
  }
}
